// create new object without defined keys
// remove true will remove filteredKeys from object; remove false will keep only filteredKeys in object
export const filterKeys = (filteredKeys, object, remove = false) => {
  const allowedKeys = getAllowedKeys(filteredKeys, object, remove)
  return Object.keys(object)
    .filter(key => allowedKeys.includes(key))
    .reduce((obj, key) => {
      return { ...obj, [key]: object[key] }
    }, {})
}

export const getAllowedKeys = (keys, object, remove) => {
  if (remove) {
    return Object.keys(object).filter(key => !keys.includes(key))
  } else {
    return keys
  }
}
